import { render, staticRenderFns } from "./BranchAdminChangeOwnershipCasesModal.vue?vue&type=template&id=34535c39"
import script from "./BranchAdminChangeOwnershipCasesModal.vue?vue&type=script&lang=js"
export * from "./BranchAdminChangeOwnershipCasesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports